import React from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import moment from 'moment';
import { getScheduleTableStyles } from './styles';

interface ScheduleTableProps {
  data: any[];
  showCourse: boolean;
  showClasses: boolean;
  showLessons: boolean;
}

export default function ScheduleTable({ data, showCourse, showClasses, showLessons }: ScheduleTableProps) {
  const theme = useTheme();
  const styles = getScheduleTableStyles(theme);

  return (
    <Box sx={styles.root}>
      <Table sx={styles.table} size="small" aria-label="schedule table">
        <TableHead>
          <TableRow>
            {showCourse && (
              <TableCell>Course</TableCell>
            )}
            {showLessons && (

              <TableCell>Lesson</TableCell>
            )}
            <TableCell>Start Date</TableCell>
            <TableCell>End Date</TableCell>
            {showClasses && (
              <TableCell>Classes</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              { showCourse && (
                <TableCell>{row.courseName}</TableCell>
              )}
              {showLessons && (

                <TableCell>{row.lessonName}</TableCell>
              )}
              <TableCell>{row.startDate ? moment(row.startDate).format('YYYY-MM-DD'): ''}</TableCell>
              <TableCell>{row.endDate ? moment(row.endDate).format('YYYY-MM-DD'): ''}</TableCell>
              { showClasses && (
                <TableCell>{row.classes}</TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}